module.exports = __webpack_public_path__ + "media/images/xpass/token-fallback-with-logo-5fd461db888c41ac6da8e1dcd98029f0.png";